<template>
    <div id="content">
        <div class="container">
            <div class="card card-payment">
                <div class="card-body">
                    <div class="card-header">
                        <span class="title" v-if="payment_status == 0">{{$t('lisa_web_payment_unsuccessfully')}}</span>
                        <span class="title" v-if="payment_status == 1">{{$t('lisa_web_payment_successfully')}}</span>
                    </div>
                    <div class="card-content">
                        <div class="payment-status payment-fail" v-if="payment_status == 0">
                            <h3><img src="/themes/ito/images/payment-failed.svg" alt=""></h3>
                            <p class="desc" style=" margin-top: 25px;">{{$t("lisa_web_your_payment_has_failed")}}</p>
                            <p class="desc">{{$t("lisa_web_sure_payment_detail_correct")}}</p>
                            <div class="d-flex justify-content-center" style="margin-top:30px">
                                <!-- <a class="ito-btn-small" href="/">{{$t("menu_item_home")}}</a>
                                <a class="ito-btn-small active" href="/parent/upgrade-account">{{$t("try_again")}}</a> -->

                                <a href="/"><button type="button" id="image-choose-img" class="btn btn-choose-image choose-image-other">{{$t("menu_item_home")}}</button></a>
                                <a href="/upgrade-account"> <button type="button" id="image-crop-save" class="btn btn-main-sm" >{{$t("try_again")}}</button></a>
                            </div>
                        </div>

                        <div class="payment-status payment-fail" v-if="payment_status == 1">
                            <h3><img src="/themes/ito/images/get-rewarded.svg" alt=""></h3>
                            <p class="desc" style=" margin-top: 25px;">{{$t("thank_you")}}</p>
                            <p class="desc">{{$t("your_payment_has_been_processed_successfully")}}</p>
                            <div class="d-flex justify-content-center" style="margin-top:30px">
                                <button type="button" id="image-crop-save"  class="btn btn-main-sm" @click="goHome">{{isMobile? $t("app"): $t("home")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {updateProfile} from '../../models/profile'
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'
    import axios from "axios";
    import {paymentDetail} from "../../models/payment";
    import {soundClick} from "../../utils/utils";

    export default {
        name: "PaymentDetail",
        title: 'Payment detail',

        data() {
            const invoice = this.$route.query.invoice || '';
            return {
                invoice: invoice,
                payment_status: '',
                isMobile: false
            };
        },

        computed: {
            ...mapGetters([
                'user_info'
            ], () => {
                if (this.user_info) {
                    return this.user_info
                }
                return this.user
            })
        },

        created() {
            this.fetch();
        },

        mounted(){
            if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
                this.isMobile = false;
            }else{
                this.isMobile = true;
            }
        },
        watch: {},

        methods: {
            async fetch() {
                const that = this;

                await axios.all([
                    paymentDetail({
                        invoice: that.invoice,
                    }),
                ]).then(axios.spread((response) => {
                    that.isLoading = false;
                    if (response.data.code != 0) {
                        return;
                    }
                    that.payment_status = response.data.results.status
                    if (that.payment_status === 1) {
                        //post mess to app
                        appHandler.postMessage('payment-done');
                    }
                }));
            },

            getSoundClick() {
                soundClick();
            },

            goHome() {
                if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
                    window.location.href = '/'
                }else{
                    window.location = 'ismart://openApp?data=payment-success&id=0'
                }
            }

        }
    }
</script>

<style scoped>
    #image-choose-img{
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.02em;
        font-weight: 700;
        font-size: 20px;
        color: #0D0D0C;
        border-radius: 4px;
        padding: 12px 40px;
        margin-right: 17px;
    }
    #image-crop-save{
        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 0.02em;
        font-weight: 700;
        font-size: 20px;
        border-radius: 4px;
        padding: 12px 40px;
    }

    .desc{
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        color: #141821;
        padding: 0;
        margin: 0;
        margin-top: 5px;
    }
    .title{
        color: #171717;
        font-weight: 700;
        font-size: 20px;
    }
    .card-header {
        background: #FFE39B;
        border-radius: 4px 4px 0px 0px;
        display: flex;
        align-items: center;
        padding: 20px 30px;
        border: none;
        position: relative;
    }
    .container{
        display: flex;
        width: 100%;
    }
    .card-payment .card-content {
        text-align: center;
        padding: 60px;
    }
    .card-body{
        padding: 0;
    }

    .card{
        width: 100%;
    }
    .payment-status p {
        font-size: 18px;
        line-height: 22px;
    }

    .btn-action-fail {
        width: 230px;
        margin: auto;
        justify-content: space-between;
        margin-top: 10px;
    }

    .btn-action-fail a,
    .btn-action-fail a:hover {
        color: #fff;
    }

    @media (max-width: 1024px) {
        .card-payment .card-content {
            text-align: center;
            padding: 30px;
        }
    }
</style>
